export default {
  isLogin: state => state.loginStatus
}
